export const FoxDiscountDetails = function (data) {
    if (!data) data = {};
    this.discountCode = data.discountCode || null;
    this.discountStart = data.discountStart || null;
    this.discountEnd = data.discountEnd || null;
    this.discountAmount = data.discountAmount || null;
    this.discountType = data.discountType || "CODE";
    this.discountValue = data.discountValue || null;
    this.discountNotes = data.discountNotes || null;
};